import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopied = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.2707 6.14895C12.3646 6.05365 12.4929 6 12.6267 6H18.1923C19.573 6 20.6923 7.11929 20.6923 8.5V9.65381H21.8462C23.2269 9.65381 24.3462 10.7731 24.3462 12.1538V23.5C24.3462 24.8807 23.2269 26 21.8462 26H14.1539C12.7732 26 11.6539 24.8807 11.6539 23.5V22.3462H10.5C9.11929 22.3462 8 21.2269 8 19.8462V10.6853C8 10.5539 8.05172 10.4278 8.14396 10.3343L12.2707 6.14895ZM12.16 21.3462C12.1579 21.3461 12.1559 21.3461 12.1539 21.3461C12.1518 21.3461 12.1498 21.3461 12.1478 21.3462H10.5C9.67157 21.3462 9 20.6746 9 19.8462V12.059C9.06904 12.095 9.14753 12.1153 9.23077 12.1153H13.6154C13.8915 12.1153 14.1154 11.8915 14.1154 11.6153V7.23071C14.1154 7.1475 14.0951 7.06903 14.0591 7H18.1923C19.0207 7 19.6923 7.67157 19.6923 8.5L19.6923 19.8462C19.6923 20.6746 19.0207 21.3462 18.1923 21.3462H12.16ZM12.6539 22.3462V23.5C12.6539 24.3284 13.3254 25 14.1539 25H21.8462C22.6746 25 23.3462 24.3284 23.3462 23.5L23.3462 12.1538C23.3462 11.3254 22.6746 10.6538 21.8462 10.6538H20.6923L20.6923 19.8462C20.6923 21.2269 19.573 22.3462 18.1923 22.3462H12.6539ZM13.1717 7H12.8359L9 10.8904V11.1717C9.06904 11.1357 9.14753 11.1153 9.23077 11.1153H13.1154V7.23071C13.1154 7.1475 13.1357 7.06903 13.1717 7Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.8875 14.0595C18.0151 14.1547 18.0375 14.3304 17.9375 14.4519L14.8723 18.1786C14.8187 18.2438 14.7374 18.283 14.6504 18.2856C14.5634 18.2882 14.4798 18.2538 14.422 18.1919L12.0741 15.6764C11.9665 15.561 11.9774 15.3843 12.0985 15.2818C12.2196 15.1792 12.4051 15.1896 12.5128 15.305L14.6271 17.5703L17.4755 14.1072C17.5754 13.9856 17.7599 13.9643 17.8875 14.0595Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCopied;
